import "dayjs/locale/es";
import dayjs from "dayjs";
export const setupDayjs = ({ locale }: { locale: string }) => {
	dayjs.locale(locale);
};
